import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { RTL } from 'Theme';
import { store } from 'Store';
import { Provider } from 'react-redux';
import { ThemeV2_0 } from 'ThemeV2.0';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'B2C';

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <RTL>
        <ThemeProvider theme={ThemeV2_0}>
          <CssBaseline />
          <Provider store={store}>
            <App msalInstance={msalInstance} />
          </Provider>
        </ThemeProvider>
      </RTL>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
